import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'

import desktop from '../../images/article-redesign/desktop.png';
import mobile from '../../images/article-redesign/mobile.png';

class ArticleRedesign extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');
    return (
      <div>
        <div className="grid">
          <div className="grid-item-wide">
            <div className="element">
              <h1 className="title">The Conversation —<br />Article redesign</h1>
            </div>
          </div>

          <div className="grid-item">
            <div className="element">
              <p>
                <strong>The Conversation</strong> is an independent source of news and views, sourced from the academic and research community and delivered direct to the public.
              </p>

              <p>
                After much thinking, discussion, reader feedback, and iterations, we strived to improve on a few key points; improving the readablity of our articles, making mobile an equal citizen, treating images as content, and making content king.
              </p>
            </div>
          </div>

          <div className="grid-item">
            <div className="element">
              <p>
                The first and most important design principle, readability, needs to have the reading experience be as pleasurable as possible. The font was been improved and the column width widened to assist in that regard.
              </p>
              <p>
                Extra clutter along the sides of a previously three column layout was either removed or shifted elsewhere, and reduced to a neater, two column layout. Content was widened and given more a centre-stage.
              </p>
            </div>
          </div>

          <div className="grid-item-padded grid-item grid-item-wide">
            <img src={ desktop } alt="Desktop" />
          </div>

          <div className="grid-item five-grid-item-prepend-three four-grid-item-prepend-two three-grid-item-prepend-one">
            <div className="element">
              <p>
                Secondly, mobile devices.
              </p>
              <p>
                We worked hard to reduce the clutter between the top of the page and the content; before, it was almost an entire device-height scroll between the top of page and the start of the article.
              </p>

            </div>
          </div>

          <div className="grid-item">
            <div className="element">
              <p>
                Now, all the author attribution &amp; disclosure, institution logos, and partnership details are hidden away under a menu. The lead image takes precedence (and in the case of the mobile 'magazine' display, it takes prominence as it's sizes to take up the full 'screen', much like a magazine full-spread).
              </p>
            </div>
          </div>

          <div className="grid-item-padded grid-item two-grid-item-two three-grid-item-two four-grid-item-two four-grid-item-prepend-two three-grid-item-prepend-one five-grid-item-two five-grid-item-prepend-three">
            <img src={ mobile } alt="Mobile" />
          </div>

          <div className="grid-item two-grid-item-two three-grid-item-two three-grid-item-prepend-one four-grid-item-two four-grid-item-prepend-two five-grid-item-two five-grid-item-prepend-three">
            <div className="element">
              <p>
                Thirdly, the font.
              </p>

              <p>
                The Conversation has traditionally featured Helvetica as it's font of choice. The departure to a more-easily readable serif font for the article body, and retaining the serif for the “wings”, the content around the body text, has improved the reading experience dramatically.
              </p>

              <p>
                Overall, we had a lot of positive feedback from an engaged readership who care a lot about the content they read.
              </p>

              <p>
                To see this in action, please read <Link to="http://www.theconversation.com" target="_blank">The Conversation</Link>.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleRedesign;




// WEBPACK FOOTER //
// ./src/pages/ArticleRedesign/index.js